"use client";

import { buttonVariants } from "@/components/rac/button";
import { cn } from "@/utils/cn";
import { type VariantProps } from "class-variance-authority";
import Link, { type LinkProps } from "next/link";
import { forwardRef } from "react";

interface ButtonLinkProps
	extends
		Omit<LinkProps, "className">,
		VariantProps<typeof buttonVariants>,
		Pick<React.AnchorHTMLAttributes<HTMLAnchorElement>, "target" | "rel"> {
	className?: string;
	children: React.ReactNode;
}

const ButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>(
	({ className, variant, size, children, ...props }, ref) => {
		return (
			<Link ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props}>
				{children}
			</Link>
		);
	},
);

ButtonLink.displayName = "ButtonLink";

export { ButtonLink };
